export default __webpack_public_path__ + "static/media/search.d78a5c73.svg";